import { type ICurrencyDropDownItem, type IDropDownItem, showToast } from 'BreetHelpers';
import { useCryptoSettings, useModalApi } from 'BreetHooks';
import { type MouseEvent, type ReactNode, useCallback, useMemo, useState } from 'react';

import type { IFundRequestContext } from '../DialogFundRequest.helpers';
import { FundRequestContext } from './FormContext';

export const FundRequestProvider = ({ children }: { children?: ReactNode }) => {
	const { openModalDirect } = useModalApi();

	const { currentReceiveCurrency } = useCryptoSettings();

	const [selectedWallet, setSelectedWallet] = useState<ICurrencyDropDownItem | undefined>();
	const [fundingMethod, setFundingMethod] = useState<string>('');

	const selectWallet = useCallback((wallet?: ICurrencyDropDownItem) => {
		setSelectedWallet(wallet);
		setFundingMethod('');
	}, []);

	const selectFundingMethod = useCallback(
		(item: IDropDownItem) => (e: MouseEvent<HTMLButtonElement>) => {
			e.preventDefault();

			if (!currentReceiveCurrency) {
				showToast('error', 'Please select a receive currency first');
				return;
			}

			let fundingMethodArg: string | undefined;

			if (selectedWallet?.currency === 'USD' && item.value === 'Crypto' && currentReceiveCurrency !== 'usd') {
				fundingMethodArg = 'crypto';
			}

			if (selectedWallet?.currency !== 'USD' && item.value === 'Crypto' && currentReceiveCurrency === 'usd') {
				fundingMethodArg = 'fiat';
			}

			if (fundingMethodArg) {
				openModalDirect({ id: 'settlementWallet', metadata: { fundingMethod: fundingMethodArg } });
				return;
			}

			setFundingMethod(item.value);
		},
		[currentReceiveCurrency, openModalDirect, selectedWallet?.currency]
	);

	const providerValue = useMemo(
		(): IFundRequestContext => ({
			selectedWallet,
			selectFundingMethod,
			selectWallet,
			fundingMethod,
		}),
		[selectedWallet, selectFundingMethod, selectWallet, fundingMethod]
	);

	return <FundRequestContext.Provider value={providerValue}>{children}</FundRequestContext.Provider>;
};
